import React, { useEffect, useMemo, useState } from "react";
import "./index.less";
import PayInfo from "./PayInfo";
// import PayOperate from "./PayOperate";
import { getQueryStringhash } from "../../utils";
import { get } from "../../axios/request";
import { Row, Spin, message, Select } from "antd";
import { returnFloat } from "../../utils";
import wxpayLogo from "../../assets/wxpay.png";
import zfbpayLogo from "../../assets/zfbpay.png";
import wxPayBlackLogo from "../../assets/wx-pay.png";
import zfbPayBlackLogo from "../../assets/zfb-pay.png";
import successOkIcon from "../../assets/success-ok.png";
import { QRCodeSVG } from "qrcode.react";
import { useParams, useNavigate } from "react-router-dom";
import LogoPng from "../../assets/logo.png";

const href = location.href;

let noPayUrl = `${location.origin}${location.pathname}`;

declare var WeixinJSBridge: any;

const payTypeWx = "3"; // 微信SDK支付
const payTypeZfb = "2"; // 支付宝支付
const payTypeWxH5 = "1"; //微信H5支付

function PayRebate() {
  document.title = "众引合作-返点支付";
  const isMobile = navigator.userAgent.indexOf("Mobile") > -1;
  const userAgent = window.navigator.userAgent.toUpperCase();
  const { kolId = "" } = useParams();
  const from = getQueryStringhash("from") || "url";
  let code = getQueryStringhash("code") || "";
  const outTradeNo = getQueryStringhash("out_trade_no") || "";
  const [infoData, setInfoData] = useState<any>({});
  const [payKolId, setPayKolId] = useState("");
  const [payStatus, setPayStatus] = useState("");
  const [kolScheduleName, setKolScheduleName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOther, setIsOther] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedPayType, setSelectedPayType] = useState(payTypeWx);

  // 根据接口返回的支付方式字段判断支持的支付方式
  const supportWx = infoData?.payMothods
    ? infoData.payMothods.includes("wechat")
    : false;
  const supportZfb = infoData?.payMothods
    ? infoData.payMothods.includes("alipay")
    : false;
  const hasMorePayOptions = supportWx && supportZfb;

  const payId = kolId || payKolId;
  const qrCodeUrl = `${noPayUrl}?from=code`;

  // 唤起支付
  const startPay = async (type: string) => {
    setBtnLoading(true);

    // 微信用户授权登录
    if (type === payTypeWx && !code) {
      window.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc129160afffb63f3&redirect_uri=${encodeURIComponent(
          href,
        )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`,
      );
      return;
    }

    // 生成支付订单
    let url = `patrick-star-api/pay/url/${type}/${payId}`;
    if (code) {
      url = url + "?code=" + code;
    }
    code = "";
    const data = await get(url);
    if (data?.success) {
      if (type === payTypeZfb) {
        // 唤起支付宝支付
        startZfbPay(data.data);
      }
      if (type === payTypeWxH5) {
        // 唤起微信H5支付
        window.location.replace(data.data);
      }
      if (type === payTypeWx) {
        // 唤起微信内置浏览器支付
        startWxPay(data.data);
      }
    } else {
      // 无法生成支付订单, 则重新刷新页面信息
      message.error(data?.msg || "请求失败");
      getPayInfo();
    }
    setBtnLoading(false);
  };

  // 唤起支付宝支付
  const startZfbPay = (data: string) => {
    const div = document.createElement("div");
    div.innerHTML = data;
    document.body.appendChild(div);
    document.forms[0].submit();
  };

  // 唤起微信内置浏览器支付
  const startWxPay = (data: string) => {
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => wxOnBridgeReady(data),
          false,
        );
      }
    } else {
      wxOnBridgeReady(data);
    }
  };
  const wxOnBridgeReady = (data: string) => {
    const wxParams = JSON.parse(data);
    WeixinJSBridge.invoke(
      "getBrandWCPayRequest",
      {
        ...wxParams,
        package: wxParams?.packageStr,
        timeStamp: wxParams?.timeStamp + "",
      },
      function (res: any) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          window.location.replace(
            `${location.origin}${location.pathname}?out_trade_no=${wxParams?.outTradeNo}`,
          );
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          window.location.replace(noPayUrl);
        } else {
          window.location.replace(noPayUrl);
        }
      },
    );
  };

  // 根据不同的浏览器, 尝试自动唤起支付, 否则显示支付方式选择页面
  function tryAutoStartPay(data: any) {
    const methods = data?.payMothods || [];
    // 唤起微信支付
    if (userAgent.indexOf("MICROMESSENGER") > 0 && methods.includes("wechat")) {
      startPay(payTypeWx);
      return;
    }

    // 唤起支付宝支付
    if (userAgent.indexOf("ALIPAYCLIENT") > 0 && methods.includes("alipay")) {
      startPay(payTypeZfb);
      return;
    }

    // 打开支付方式选择页面
    setIsOther(true);
  }

  useEffect(() => {
    if (outTradeNo) {
      getPayStatus();
    }
  }, []);

  useEffect(() => {
    if (kolId) {
      getPayInfo();
    }
  }, [kolId]);

  // 获取支付状态
  const getPayStatus = async () => {
    setLoading(true);
    const data = await get(`patrick-star-api/pay/result/${outTradeNo}`);
    if (data?.success) {
      setPayStatus(data.data.payStatus);
      setKolScheduleName(data.data.kolScheduleName);
      if (["支付超时", "支付失败"].includes(data.data.payStatus)) {
        getPayKolId();
      }
    }
    setLoading(false);
  };

  // 根据支付状态获取kolId
  const getPayKolId = async () => {
    setLoading(true);
    const data = await get(
      `patrick-star-api/pay/last-schedule-rebate-info/${outTradeNo}`,
    );
    if (data?.success) {
      setPayKolId(data.data.kolScheduleId);
    }
    setLoading(false);
  };

  // 请求达人信息
  const getPayInfo = async () => {
    setLoading(true);
    const data = await get(
      `patrick-star-api/kol-schedule-collected-rebate/last-schedule-rebate-info/${kolId}`,
    );
    if (data?.success) {
      setInfoData(data.data);
      // 根据接口返回的支付方式字段设置默认支付方式
      const methods = data.data.payMothods || [];
      if (!methods.includes("wechat") && methods.includes("alipay")) {
        setSelectedPayType(payTypeZfb);
      } else if (methods.includes("wechat")) {
        setSelectedPayType(payTypeWx);
      }
      // 手机扫描进入页面或者微信授权完成后进入页面, 尝试自动唤起支付
      if (data.data.uncollectedAmount > 0 && (from === "code" || code)) {
        tryAutoStartPay(data.data);
      }
    } else {
      message.error(data?.msg || "请重新复制链接！");
    }
    setLoading(false);
  };

  // 跳转到反馈页面
  const goFeedback = () => {
    navigate(`/kol/feedback/${kolId}`);
  };

  // 支付方式下拉选择
  const PayTypeSelectList = useMemo(() => {
    if (!hasMorePayOptions) return null;
    // 根据当前选中的支付方式，显示另一种可用的支付方式
    const altPayType = selectedPayType === payTypeWx ? payTypeZfb : payTypeWx;
    const altPayLabel = altPayType === payTypeWx ? "微信" : "支付宝";
    return (
      <Select placeholder="更多支付方式" onChange={setSelectedPayType}>
        <Select.Option value={altPayType}>使用{altPayLabel}支付</Select.Option>
      </Select>
    );
  }, [setSelectedPayType, selectedPayType, hasMorePayOptions]);

  return (
    <div className={isMobile ? "container-mobile" : "container-pc"}>
      <Spin spinning={loading}>
        <div className="container">
          {/* 未支付页面 */}
          {payId && payStatus !== "支付成功" && (
            <div className={isMobile ? "" : "content-pc"}>
              {!isMobile && <img src={LogoPng} alt="" className="logo" />}

              <div className="content">
                {/* 达人支付信息显示 */}
                <PayInfo infoData={infoData} isMobile={isMobile} />

                {/* 手机端支付方式选择 */}
                {!!infoData?.uncollectedAmount &&
                  (from === "url" || isOther) &&
                  isMobile && (
                    <div>
                      <Row justify="center" className="mt40 mb14">
                        <Spin spinning={btnLoading || !!code}>
                          {supportWx && selectedPayType === payTypeWx && (
                            <div
                              className="pay-way wx"
                              onClick={() =>
                                startPay(
                                  userAgent.indexOf("MICROMESSENGER") > 0
                                    ? payTypeWx
                                    : payTypeWxH5,
                                )
                              }
                            >
                              <div>
                                <img src={wxpayLogo} alt="" />
                              </div>
                              <div>
                                <div>微信支付</div>
                                <div className="pay-money">
                                  ￥
                                  {returnFloat(
                                    infoData?.uncollectedAmount || 0,
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          {supportZfb && selectedPayType === payTypeZfb && (
                            <div
                              className="pay-way zfb"
                              onClick={() => startPay(payTypeZfb)}
                            >
                              <div>
                                <img src={zfbpayLogo} alt="" />
                              </div>
                              <div>
                                <div>支付宝支付</div>
                                <div className="pay-money">
                                  ￥
                                  {returnFloat(
                                    infoData?.uncollectedAmount || 0,
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </Spin>
                      </Row>
                      <Row justify="center" className="mt10 mb14">
                        {PayTypeSelectList}
                      </Row>
                      <div className="problem-tips">
                        如果您对返点金额有异议或您已支付，请点击
                        <span className="feedback" onClick={goFeedback}>
                          问题反馈
                        </span>
                      </div>
                      <div className="problem-tips">
                        我司将尽快安排人员为您处理。
                      </div>
                      <div className="payment">
                        收款方：<span>上海智声广告有限公司</span>
                      </div>
                    </div>
                  )}
              </div>

              {/* PC端支付方式选择 */}
              {!isMobile && (
                <div className="pay-code">
                  {!!infoData?.uncollectedAmount ? (
                    <>
                      <div>收款方：上海智声广告有限公司</div>
                      <div className="pay-amount">
                        ￥
                        <span>
                          {returnFloat(infoData?.uncollectedAmount || 0)}
                        </span>
                      </div>
                      <div>
                        <QRCodeSVG value={qrCodeUrl} size={150} />
                      </div>

                      <div className="pay-tips">
                        {selectedPayType === payTypeWx && (
                          <>
                            <img src={wxPayBlackLogo} alt="" />
                            使用 <span>微信</span> 扫码支付
                          </>
                        )}
                        {selectedPayType === payTypeZfb && (
                          <>
                            <img src={zfbPayBlackLogo} alt="" />
                            使用 <span>支付宝</span> 扫码支付
                          </>
                        )}
                      </div>

                      <div style={{ marginBottom: "25px" }}>
                        {PayTypeSelectList}
                      </div>

                      <div className="problem-tips">
                        如果您对返点金额有异议或您已支付，请点击
                        <span className="feedback" onClick={goFeedback}>
                          问题反馈
                        </span>
                      </div>
                      <div className="problem-tips">
                        我司将尽快安排人员为您处理。
                      </div>
                    </>
                  ) : (
                    <span>返点已支付！感谢您的配合，期待下次合作 ！</span>
                  )}
                </div>
              )}
            </div>
          )}

          {/* 支付成功页面 */}
          {payStatus === "支付成功" && (
            <div className="content-success">
              <div className="success-text">支付成功</div>
              <img src={successOkIcon} alt="" />
              <div className="greeting">
                尊敬的<span>{kolScheduleName}</span>
              </div>
              <div className="hint">
                返点支付成功！感谢您的配合，期待下次合作 ！
              </div>
              <img src={LogoPng} alt="" className="logo" />
            </div>
          )}
        </div>
      </Spin>

      {!isMobile && (
        <div className="footer-title">
          版权所有 上海众引文化传播股份有限公司 2013 Copyright
          MGCC 沪ICP备08008574
        </div>
      )}
    </div>
  );
}

export default PayRebate;
